/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Achievement_First_Pr_HintInputs */

const en_us2_achievement_first_pr_hint = /** @type {(inputs: Achievement_First_Pr_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beat one of your records`)
};

const pt_br2_achievement_first_pr_hint = /** @type {(inputs: Achievement_First_Pr_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bater um recorde seu`)
};

const es_419_achievement_first_pr_hint = /** @type {(inputs: Achievement_First_Pr_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supera uno de tus récords`)
};

const pt_pt2_achievement_first_pr_hint = /** @type {(inputs: Achievement_First_Pr_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bater um recorde teu`)
};

const fr_fr2_achievement_first_pr_hint = /** @type {(inputs: Achievement_First_Pr_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Battre un de tes records`)
};

const de_de2_achievement_first_pr_hint = /** @type {(inputs: Achievement_First_Pr_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einen deiner Rekorde brechen`)
};

const it_it2_achievement_first_pr_hint = /** @type {(inputs: Achievement_First_Pr_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Batti uno dei tuoi record`)
};

/**
* | output |
* | --- |
* | "Beat one of your records" |
*
* @param {Achievement_First_Pr_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const achievement_first_pr_hint = /** @type {((inputs?: Achievement_First_Pr_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Achievement_First_Pr_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_achievement_first_pr_hint(inputs)
	if (locale === "es-419") return es_419_achievement_first_pr_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_achievement_first_pr_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_achievement_first_pr_hint(inputs)
	if (locale === "de-DE") return de_de2_achievement_first_pr_hint(inputs)
	if (locale === "it-IT") return it_it2_achievement_first_pr_hint(inputs)
	return en_us2_achievement_first_pr_hint(inputs)
});
export { achievement_first_pr_hint as "achievement.first_pr_hint" }